module.exports = "/_next/static/images/97b4f63025a4c15fbf5f87a31a6b30c8-rewards-illustration@1x.png.webp";